export default __webpack_public_path__ + "static/media/080_finish_good.last.38287dd9.avif";